/* eslint-disable no-magic-numbers */
'use client';

import { type FC } from 'react';
import { useMediaQuery } from '@spellix/hooks';
import { FlickeringGrid } from '@/lib/components';

export const FooterBottom: FC = () => {
  const tablet = useMediaQuery('(max-width: 1024px)');

  return (
    <div className="relative z-0 mt-12 w-full h-48 md:h-64">
      <div className="absolute inset-0 bg-gradient-to-t from-transparent to-background z-10 from-40%" />
      <div className="absolute inset-0 mx-6">
        <FlickeringGrid
          text={tablet ? 'Crystalyze' : 'Supercharge your trading '}
          fontSize={tablet ? 70 : 90}
          className="w-full h-full"
          squareSize={2}
          gridGap={tablet ? 2 : 3}
          color="#6B7280"
          maxOpacity={0.3}
          flickerChance={0.1}
        />
      </div>
    </div>
  );
};
